import React from 'react';
import { API_ROOT } from '../../../../core/duck';
import Box from '../../../../components/Box';
import Spinner from '../../../../components/Spinner';
import CheckMark from '../../../../components/CheckMark';


class PasswordReset extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isFetching: false,
      done: false
    }
  }

  handleSubmit = (e) => {
    const email = this.refs.email.value;

    e.preventDefault();

    // TODO: email validation
    if (email !== '') {
      this.setState({isFetching: true});

      fetch(`${API_ROOT}/v1/users/password_reset/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: email,
        })
      })
        .then(() => {
          this.setState({isFetching: false, done: true});
        });
    }
  };

  render() {
    const { isFetching, done } = this.state;

    return (
      <div className="row" style={{marginTop: '10px'}}>
        <div className="col-xs-6 col-xs-offset-3">
          {done &&
          <Box title="Reset Password">
            <CheckMark size={40} message="Email sent!"/>
            <p style={{textAlign: 'center'}}>
              If this is a valid account, your email is on its way!<br/>
              For your security, the reset link is valid only for the next 24 hours.<br/>
              If you don’t see the email in your inbox, please check your spam folder.
            </p>
          </Box>
          }
          {!done &&
          <form role="form" onSubmit={this.handleSubmit}>
            {isFetching && <Spinner/>}
            <Box title="Reset Password"
                 footer={<button className={"btn btn-default" + (isFetching ? ' disabled' : '')}>Submit</button>}>
              <div className="form-group">
                <label htmlFor="inputEmail">
                  Please enter your email address and we'll send you instructions to reset your password.
                </label>
                <input type="email" ref="email" className="form-control" id="inputEmail" placeholder="Enter email"/>
              </div>
            </Box>
          </form>
          }
        </div>
        {/* /.col */}
      </div>
    );
  }
}

export default PasswordReset;



// WEBPACK FOOTER //
// ./src/features/auth/components/PasswordReset/PasswordReset.js